/**
 * 심볼 리스트 탭 상수
 */
export const SYMBOL_LIST_TAB = {
    ALL: 'all',
    WATCHLIST: 'watchlist',
    POSSESSION: 'possession',
};
//# sourceMappingURL=symbol-list.js.map